import React from "react";
import { Title } from "../open-title";
import { AuthingButton } from "../../components/AuthingButton";
import { useTranslation } from "react-i18next";
import "./styles.less";

export const JoinAuthing = () => {
  const { t } = useTranslation();

  return (
    <div className="open-page-join">
      <Title title={t("open.join.title")} desc={t("open.join.desc")} />
      <div className="open-page-join-button">
        <AuthingButton
          onClick={() => {
            window.open("https://docs.authing.cn/v2/apn/");
          }}
        >
          {t("open.join.btnText")}
        </AuthingButton>
      </div>
    </div>
  );
};
